let serverHost = {
	"user": "https://user.ocn.com.cn",
	"tag": "https://tag.ocn.com.cn",
	"cyl": "https://lian.ocn.com.cn",
	"crm": "https://xmapi.zhaoshangdanao.com",
	"common": "https://common.ocn.com.cn",
	"metall": "https://www.chanyedanao.com.cn",
};
let localHost = {
	// "tag": "http://i9o1vfrc.shenzhuo.vip:30332",
	// "user": "http://m49128s358.51vip.biz:38423",
	// "cyl": "http://m49128s358.51vip.biz:53767",
	// "crm": "http://m49128s358.51vip.biz:56509",
	/*-----------------------------------------*/
	"cyl": "http://192.168.1.86:8350",
	"crm": "http://192.168.1.86:2523",
	"tag": "http://192.168.1.86:8361",
	// ------------------------------------------
	// "tag": "http://192.168.1.86:8361",
	// "cyl": "http://192.168.1.86:2247",
	// "crm": "http://192.168.1.86:8353",

	/*-----------------------------------------*/
	"user": "http://192.168.1.86:8610",
	"common": "http://192.168.1.86:5118",
	"metall": "http://192.168.1.86:6772",

};
let isLocal = false;
var hrefl = window.location.href.toLowerCase();

if (process.env.NODE_ENV === 'development') {
	isLocal = true;
} else {
	isLocal = false;
}
window.getApiUrl = function (path, system, args) {
	let url = getHost(system) + path;
	let symbol = url.indexOf("?") > 0 ? "&" : "?";
	if (args) {
		for (let key in args) {
			if (args[key] != '' && args[key] != 0) {
				url += symbol + key + "=" + encodeURIComponent(args[key]);
				symbol = "&";
			}
		}
	}
	return url;
};
function getHost(system) {
	if (isLocal) {
		return localHost[system];
	}
	return serverHost[system];
}
var websiteList = [
	{name:"二十二冶版",type:1,url:"zk.ocn.com.cn"},
	{name:"协会版",type:2,url:"www.xiangmuleida.com"},
	{name:"协会版",type:2,url:"xiangmuleida.com"},
	{name:"会员版",type:3,url:"vip.xiangmuleida.com"},
	{name:"会员版",type:4,url:"sz.xiangmuleida.com"}, //深圳版没有联系人
];
var testWebsiteUrl = "vip.xiangmuleida.com";//修改链接地址就可以直接切换本地系统版本
let ajaxapi = {
	'getWebsiteType': function () {
		var websiteHref = isLocal ? testWebsiteUrl : window.location.href.toLowerCase();
		// var websiteHref = testWebsiteUrl;
		var curwebsit = [];
		for (var i = 0; i < websiteList.length; i++) {
			if (websiteHref.indexOf(websiteList[i].url) > -1) {
				curwebsit = websiteList[i];
			}
		}
		// console.log('当前端口',curwebsit);
		return curwebsit;
	},
	"user": {
		"user": {
			"login": function (args) {
				return getApiUrl('/api/user/v1/user/login', 'user', args);
			}
		}
	},
	"cyl": {
		"deepseek": {
			"enterprise": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Enterprise', 'cyl', args);
			},
			"market": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Market', 'cyl', args);
			},
			"history": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/History', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Detail', 'cyl', args);
			},
			"rename": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Rename', 'cyl', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/cyl/v1/deepseek/Delete', 'cyl', args);
			},
		},
		"allIndustryData": {
			"priceChange": function (args) {
				return getApiUrl('/api/cyl/v1/allIndustryData/priceChange', 'cyl', args);
			},
			"operate": function (args) {
				return getApiUrl('/api/cyl/v1/allIndustryData/operate', 'cyl', args);
			},
			 
		},
		"report": {
			"industryList": function (args) {
				return getApiUrl('/api/cyl/v1/report/industryList', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/report/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/report/detail', 'cyl', args);
			},
			"futureIndustry": function (args) {
				return getApiUrl('/api/cyl/v1/report/futureIndustry', 'cyl', args);
			},
		},
		
		"statsData": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/statsData/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/statsData/detail', 'cyl', args);
			},
		},
		"market": {
			"detail2": function (args) {
				return getApiUrl('/api/cyl/v1/market/detail2', 'cyl', args);
			},
		},
		"industryData": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/industryData/list', 'cyl', args);
			},
			"list2": function (args) {
				return getApiUrl('/api/cyl/v1/industryData/list2', 'cyl', args);
			},
			"areaList": function (args) {
				return getApiUrl('/api/cyl/v1/industryData/areaList', 'cyl', args);
			},
		},
		"userMessage": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/userMessage/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/userMessage/detail', 'cyl', args);
			},
			"latest": function (args) {
				return getApiUrl('/api/cyl/v1/userMessage/latest', 'cyl', args);
			},

		},
		"map": {
			"entlistbycity": function (args) {
				return getApiUrl('/api/cyl/v1/map/entlistbycity', 'cyl', args);
			},
			"mapdetail": function (args) {
				return getApiUrl('/api/cyl/v1/map/mapdetail', 'cyl', args);
			},
			"mapsimpledetail": function (args) {
				return getApiUrl('/api/cyl/v1/map/mapsimpledetail', 'cyl', args);
			},
			"mapcity": function (args) {
				return getApiUrl('/api/cyl/v1/map/mapcity', 'cyl', args);
			},
			"collect": function (args) {
				return getApiUrl('/api/cyl/v1/map/collect', 'cyl', args);
			},
			"enterpriseList": function (args) {
				return getApiUrl('/api/cyl/v1/map/EnterpriseList', 'cyl', args);
			},
		},
		'enterprisenews': {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterprisenews/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/enterprisenews/detail', 'cyl', args);
			},
		},
		'dynamicNotify': {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/dynamicNotify/list', 'cyl', args);
			},
			"read": function (args) {
				return getApiUrl('/api/cyl/v1/dynamicNotify/read', 'cyl', args);
			},

		},
		'association': {
			"city": function (args) {
				return getApiUrl('/api/cyl/v1/association/city', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/association/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/association/detail', 'cyl', args);
			},
			"enterpriselist": function (args) {
				return getApiUrl('/api/cyl/v1/association/enterpriselist', 'cyl', args);
			},
		},
		"competitive": {
			"comprehensive": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/comprehensive', 'cyl', args);
			},
			"scienceTech": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/scienceTech', 'cyl', args);
			},
			"industry": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/industry', 'cyl', args);
			},
			"localInvest": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/localInvest', 'cyl', args);
			},
			"financing": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/financing', 'cyl', args);
			},
			"externalInvest": function (args) {
				return getApiUrl('/api/cyl/v1/competitive/externalInvest', 'cyl', args);
			},
		},
		'commerce': {
			"city": function (args) {
				return getApiUrl('/api/cyl/v1/commerce/city', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/commerce/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/commerce/detail', 'cyl', args);
			},
			"enterpriselist": function (args) {
				return getApiUrl('/api/cyl/v1/commerce/enterpriselist', 'cyl', args);
			},
		},
		'forcapenterprise': {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/forcapenterprise/list', 'cyl', args);
			},
			"export": function (args) {
				return getApiUrl('/api/cyl/v1/forcapenterprise/export', 'cyl', args);
			},

		},
		'foreignenterprise': {
			"paramList": function (args) {
				return getApiUrl('/api/cyl/v1/foreignenterprise/paramList', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/foreignenterprise/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/foreignenterprise/detail', 'cyl', args);
			},

		},
		'userenterprise': {
			"add": function (args) {
				return getApiUrl('/api/cyl/v1/userenterprise/add', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/userenterprise/list', 'cyl', args);
			},
			"remove": function (args) {
				return getApiUrl('/api/cyl/v1/userenterprise/remove', 'cyl', args);
			},
		},
		"search": {
			"enterprise": function (args) {
				return getApiUrl('/api/cyl/v1/search/enterprise', 'cyl', args);
			},
		},
		"enterprise": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/detail', 'cyl', args);
			},
			"detail2": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/detail2', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/list', 'cyl', args);
			},
			"unlock": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/unlock', 'cyl', args);
			},
			"export": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/export', 'cyl', args);
			},
			"comparison": function (args) {
				return getApiUrl('/api/cyl/v1/enterprise/comparison', 'cyl', args);
			},
		},
		"enterpriseComparison": {
			"entInfo": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/entInfo', 'cyl', args);
			},
			"save": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/save', 'cyl', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/delete', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/detail', 'cyl', args);
			},
			"addEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/addEnterprise', 'cyl', args);
			},
			"deleteEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/deleteEnterprise', 'cyl', args);
			},
			"enterpriseList": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseComparison/enterpriseList', 'cyl', args);
			},
		},
		"enterpriseCityRelation": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseCityRelation/list', 'cyl', args);
			},
		},
		"enterpriseEdition": {
			"macrobg": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseEdition/macroBg', 'cyl', args);
			},
			"industryenv": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseEdition/industryEnv', 'cyl', args);
			},
			"strategy": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseEdition/strategy', 'cyl', args);
			},
			"investdynamic": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseEdition/investDynamic', 'cyl', args);
			}
		},
		"ocnreport": {
			"category": function (args) {
				return getApiUrl('/api/cyl/v1/ocnReport/category', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/ocnReport/reportList', 'cyl', args);
			},
		},
		"enterpriseRelation": {
			"addEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/addEnterprise', 'cyl', args);
			},
			"deleteEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/deleteEnterprise', 'cyl', args);
			},
			"enterpriseList": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/enterpriseList', 'cyl', args);
			},
			"deleteResult": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/deleteResult', 'cyl', args);
			},
			"calculate": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/calculate', 'cyl', args);
			},
			"save": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/save', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/detail', 'cyl', args);
			},
			"search": function (args) {
				return getApiUrl('/api/cyl/v1/enterpriseRelation/search', 'cyl', args);
			},
		},
		"localchain": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/localChain/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/localChain/detail', 'cyl', args);
			},
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/localChain/getNotion', 'cyl', args);
			},
			"set": function (args) {
				return getApiUrl('/api/cyl/v1/localChain/setNotion', 'cyl', args);
			},
		},
		"collect": {
			"add": function (args) {
				return getApiUrl('/api/cyl/v1/collect/add', 'cyl', args);
			},
			"remove": function (args) {
				return getApiUrl('/api/cyl/v1/collect/remove', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/collect/list', 'cyl', args);
			},
			"export": function (args) {
				return getApiUrl('/api/cyl/v1/collect/export', 'cyl', args);
			},
			"map": function (args) {
				return getApiUrl('/api/cyl/v1/collect/map', 'cyl', args);
			},
			"enterpriseRelated": function (args) {
				return getApiUrl('/api/cyl/v1/collect/enterpriseRelated', 'cyl', args);
			},
			"enterpriseRelatedLevel2": function (args) {
				return getApiUrl('/api/cyl/v1/collect/enterpriseRelatedLevel2', 'cyl', args);
			},
			"addshortList": function (args) {
				return getApiUrl('/api/cyl/v1/collect/addShortList', 'cyl', args);
			},
			"removeshortList": function (args) {
				return getApiUrl('/api/cyl/v1/collect/removeShortList', 'cyl', args);
			},
		},
		"zttopic": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/zt/detail', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/zt/list', 'cyl', args);
			},
		},
		"land": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/land/list', 'cyl', args);
			},
		},
		"govementchart": {
			"economy": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/economy', 'cyl', args);
			},
			"industryland": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/industryLand', 'cyl', args);
			},
			"enterprisenum": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/enterpriseNum', 'cyl', args);
			},
			"investenv": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/investEnv', 'cyl', args);
			},
			"competitive": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/competitive', 'cyl', args);
			},
			"investment": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/investment', 'cyl', args);
			},
			"macrodata": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/macrodata', 'cyl', args);
			},
			"enterprisecount": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/enterpriseCount', 'cyl', args);
			},
			"mapserch": function (args) {
				return getApiUrl('/static/map/dist/#/', 'cyl', args);
			},
			"busiInvestAtals": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/busiInvestAtals', 'cyl', args);
			},
			"investProject": function (args) {
				return getApiUrl('/api/cyl/v1/governmentChart/investProject', 'cyl', args);
			},
		},
		"govsaaschart": {
			"macrodata": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/macrodata', 'cyl', args);
			},
			"competitive": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/competitive', 'cyl', args);
			},
			"investment": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/investment', 'cyl', args);
			},
			"investenv": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/investEnv', 'cyl', args);
			},
			"investProject": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/investProject', 'cyl', args);
			},
			"industryland": function (args) {
				return getApiUrl('	/api/cyl/v1/govSaasChart/industryLand', 'cyl', args);
			},
			"enterprisecount": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/enterpriseCount', 'cyl', args);
			},
			"industryDevelop": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/industryDevelop', 'cyl', args);
			},
			"busiInvestAtals": function (args) {
				return getApiUrl('	/api/cyl/v1/govSaasChart/busiInvestAtals', 'cyl', args);
			},
			"chainurl": function (args) {
				return getApiUrl('/static/graph/chart.html', 'cyl', args);
			},
			"qxEcoDevelop": function (args) {
				return getApiUrl('/api/cyl/v1/govSaasChart/qxEcoDevelop', 'cyl', args);
			},
		},
		"specialTown": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/specialTown/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/specialTown/detail', 'cyl', args);
			},
			"notionList": function (args) {
				return getApiUrl('/api/cyl/v1/specialTown/notionList', 'cyl', args);
			},
		},
		"projectnews": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/projectNews/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/projectNews/detail', 'cyl', args);
			},
			"paramList": function (args) {
				return getApiUrl('/api/cyl/v1/projectNews/paramList', 'cyl', args);
			},
		},
		"park": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/park/detail', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/park/list', 'cyl', args);
			}
		},
		"news": {
			"datelist": function (args) {
				return getApiUrl('/api/cyl/v1/news/datelist', 'cyl', args);
			},
			"paramlist": function (args) {
				return getApiUrl('/api/cyl/v1/news/paramList', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/news/detail', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/news/list', 'cyl', args);
			}
		},
		"academy": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/academy/detail', 'cyl', args);
			},
			"detail2": function (args) {
				return getApiUrl('/api/cyl/v1/academy/detail2', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/academy/list', 'cyl', args);
			}
		},
		"investorg": {
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/investorg/detail', 'cyl', args);
			},
			"enterpriseList": function (args) {
				return getApiUrl('/api/cyl/v1/investorg/enterpriseList', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/investorg/list', 'cyl', args);
			}
		},
		"area": {
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/area/province', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/static/data/city_api.js', 'cyl', args);
			},
		},

		"chart": {
			"index": function (args) {
				return getApiUrl('/api/cyl/v1/chart/index', 'cyl', args);
			},
			"bigen": function (args) {
				return getApiUrl('/api/cyl/v1/chart/bigEnterprise', 'cyl', args);
			},
			"smen": function (args) {
				return getApiUrl('/api/cyl/v1/chart/smallEnterprise', 'cyl', args);
			},
			"investorg": function (args) {
				return getApiUrl('/api/cyl/v1/chart/investOrg', 'cyl', args);
			},
		},
		"parameter": {
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/parameter/industry', 'cyl', args);
			},
			"chain": function (args) {
				return getApiUrl('/api/cyl/v1/parameter/chain', 'cyl', args);
			},
			"demandsupply": function (args) {
				return getApiUrl('/api/cyl/v1/parameter/demandsupply', 'cyl', args);
			},
			"stockindustry": function (args) {
				return getApiUrl('/api/cyl/v1/parameter/stockIndustry', 'cyl', args);
			},
		},
		"techdemand": {
			"post": function (args) {
				return getApiUrl('/api/cyl/v1/techdemand/post', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/techdemand/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/techdemand/detail', 'cyl', args);
			},
		},
		"techsupply": {
			"post": function (args) {
				return getApiUrl('/api/cyl/v1/techsupply/post', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/techsupply/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/techsupply/detail', 'cyl', args);
			},
		},
		"chain": {
			"download": function (args) {
				return getApiUrl('/api/cyl/v1/chain/download', 'cyl', args);
			},
			"nodelist": function (args) {
				return getApiUrl('/api/cyl/v1/chain/nodelist', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/chain/list', 'cyl', args);
			},
			"get": function (args) {
				return getApiUrl('/api/cyl/v1/chain/detail', 'cyl', args);
			},
			"detail2": function (args) {
				return getApiUrl('/api/cyl/v1/chain/detail2', 'cyl', args);
			},
			"index": function (args) {
				return getApiUrl('/api/cyl/v1/chain/index', 'cyl', args);
			},
		},
		"notion": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/notion/list', 'cyl', args);
			},
			"chainenterprise": function (args) {
				return getApiUrl('/api/cyl/v1/notion/enterprise', 'cyl', args);
			},
			"chainenterprisedetail": function (args) {
				return getApiUrl('/api/cyl/v1/notion/enterpriseList', 'cyl', args);
			},
			"notionEnterprseNum": function (args) {
				return getApiUrl('/api/cyl/v1/notion/enterpriseNum', 'cyl', args);
			},
		},
		"usercenter": {
			"index": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/index', 'cyl', args);
			},
			"updatenotion": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/updateNotion', 'cyl', args);
			},
			"updatepassword": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/updatePassword', 'cyl', args);
			},
			"baseinfo": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/baseInfo', 'cyl', args);
			},
			"updatebaseinfor": function (args) {
				return getApiUrl('/api/cyl/v1/usercenter/updateBaseinfo', 'cyl', args);
			},
		},
		"home": {
			"all": function (args) {
				return getApiUrl('/api/cyl/v1/home/all', 'cyl', args);
			},
			"chain": function (args) {
				return getApiUrl('/api/cyl/v1/home/chain', 'cyl', args);
			},
			"enterprise": function (args) {
				return getApiUrl('/api/cyl/v1/home/enterprise', 'cyl', args);
			},
			"academy": function (args) {
				return getApiUrl('/api/cyl/v1/home/academy', 'cyl', args);
			},
			"investorg": function (args) {
				return getApiUrl('/api/cyl/v1/home/investorg', 'cyl', args);
			},
			"notice": function (args) {
				return getApiUrl('/api/cyl/v1/home/notice', 'cyl', args);
			},
		},
		"GovInvestAlg": {
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/govInvestAlg/detail', 'cyl', args);
			},
		},
		"OCNNews": {
			"keywords": function (args) {
				return getApiUrl('/api/cyl/v1/ocnNews/keywords', 'cyl', args);
			},
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/ocnNews/list', 'cyl', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/cyl/v1/ocnNews/detail', 'cyl', args);
			},
		},
		"investclue": {
			"industry": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/industry', 'cyl',
					args); //以前的以商招商线索现已改为business，接口列表已隐藏但还能用
			},
			"area": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/area', 'cyl',
					args); //以前的重点区域招商线索现已改为keyarea，接口列表已隐藏但还能用
			},
			"finance": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/finance', 'cyl',
					args); //以前的资本招商线索现已改为capital，接口列表已隐藏但还能用
			},
			"ipo": function (args) {
				return getApiUrl('	/api/cyl/v1/investClue/ipo', 'cyl', args);
			},
			"business": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/business', 'cyl', args);
			},
			"keyarea": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/keyarea', 'cyl', args);
			},
			"hotspot": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/hotspotIndustry', 'cyl', args);
			},
			"capital": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/capital', 'cyl', args);
			},
			"rankList": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/rankList', 'cyl', args);
			},
			"rankDetail": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/rankDetail', 'cyl', args);
			},
			"EnterpriseInvestmentWindow": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/EnterpriseInvestmentWindow', 'cyl', args);
			},
			"IndustryInvestmentWindow": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/IndustryInvestmentWindow', 'cyl', args);
			},
			"relationEnterprise": function (args) {
				return getApiUrl('/api/cyl/v1/investClue/relationEnterprise', 'cyl', args);
			},
		},
		"export": {
			"list": function (args) {
				return getApiUrl('/api/cyl/v1/export/enterprise', 'cyl', args);
			},
		},
	},
	"tag": {
		"notionExtend": {
			"list": function (args) {
				return getApiUrl('/api/tag/v1/notionExtend/list', 'tag', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/tag/v1/notionExtend/detail', 'tag', args);
			}
		},
		"article": {
			"get": function (args) {
				return getApiUrl('/cmsapi/v1/article/get', 'tag', args);
			}
		},
		"apicode": {
			"get": function (args) {
				return getApiUrl('/api/tag/v1/apicode/get', 'tag', args);
			}
		},
		"notion": {
			"list": function (args) {
				return getApiUrl('/api/tag/v1/notion/list', 'tag', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/tag/v1/notion/detail', 'tag', args);
			}
		},
		"category": {
			"list": function (args) {
				return getApiUrl('/api/tag/v1/tag/category', 'tag', args);
			}
		},
		"tag": {
			"list": function (args) {
				return getApiUrl('/api/tag/v1/tag/list', 'tag', args);
			}
		},
	},
	"common": {
		"sms": {
			"isSmsLogin": function (args) {
				return getApiUrl('/api/investapi/v1/sms/isSmsLogin', 'common', args);
			},
			"send": function (args) {
				return getApiUrl('/api/investapi/v1/sms/send', 'common', args);
			},
		},
		'ExamineNotice': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/examineNotice/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/examineNotice/Detail', 'common', args);
			},
			"Export": function (args) {
				return getApiUrl('/api/intelapi/v1/examineNotice/Export', 'common', args);
			}
		},
		'ApprovalNotice': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/approvalNotice/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/approvalNotice/Detail', 'common', args);
			}
		},
		'RecordPublic': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/recordPublic/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/recordPublic/Detail', 'common', args);
			},
			"Export": function (args) {
				return getApiUrl('/api/intelapi/v1/recordPublic/Export', 'common', args);
			}
		},
		'EnergyNotice': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/energyNotice/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/energyNotice/Detail', 'common', args);
			}
		},
		'LandPreapproval': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/landPreapproval/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/landPreapproval/Detail', 'common', args);
			},
			"Export": function (args) {
				return getApiUrl('/api/intelapi/v1/landPreapproval/Export', 'common', args);
			}
		},
		'LandPermit': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/landPermit/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/landPermit/Detail', 'common', args);
			},
			"Export": function (args) {
				return getApiUrl('/api/intelapi/v1/landPermit/Export', 'common', args);
			}
		},
		'ConstructionPermit': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionPermit/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionPermit/Detail', 'common', args);
			}
		},
		'EiaReport': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/eiaReport/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/eiaReport/Detail', 'common', args);
			},
			"Export": function (args) {
				return getApiUrl('/api/intelapi/v1/eiaReport/Export', 'common', args);
			}
		},
		'buildPermit': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/buildPermit/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/buildPermit/Detail', 'common', args);
			}
		},
		'tenderingBidding': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/tenderingBidding/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/tenderingBidding/Detail', 'common', args);
			}
		},
		'allGovernmentProject': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/allGovernmentProject/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/allGovernmentProject/SourceList', 'common', args);
			},
			"Export": function (args) {
				return getApiUrl('/api/intelapi/v1/allGovernmentProject/Export', 'common', args);
			}

		},
		'Parameter': {
			"ExamineNoticeType": function (args) {
				return getApiUrl('/api/intelapi/v1/parameter/ExamineNoticeType', 'common', args);
			},
			"Industry": function (args) {
				return getApiUrl('/api/intelapi/v1/parameter/Industry', 'common', args);
			},
			"TenderingProjectTypeName": function (args) {
				return getApiUrl('/api/intelapi/v1/parameter/TenderingProjectTypeName', 'common', args);
			},
			"ContactRoleType": function (args) {
				return getApiUrl('/api/intelapi/v1/parameter/ContactRoleType', 'common', args);
			},
			
		},
		'contact': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/contact/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/contact/Detail', 'common', args);
			},
			"DetailList": function (args) {
				return getApiUrl('/api/intelapi/v1/contact/DetailList', 'common', args);
			},
		},
		'constructionProject': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionProject/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionProject/Detail', 'common', args);
			},
			"Parameter": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionProject/Parameter', 'common', args);
			},
		},
		'constructionUnit': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionUnit/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionUnit/Detail', 'common', args);
			},
			"Detail2": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionUnit/Detail2', 'common', args);
			},
			"Parameter": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionUnit/Parameter', 'common', args);
			},
			"EnterpriseBaseInfo": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionUnit/EnterpriseBaseInfo', 'common', args);
			},
			"EnterpriseDetail": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionUnit/EnterpriseDetail', 'common', args);
			},
		},
		'constructionPersonnel': {
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionPersonnel/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionPersonnel/Detail', 'common', args);
			},
		},
		'Land': {
			"Related": function (args) {
				return getApiUrl('/api/intelapi/v1/land/Related', 'common', args);
			},
		},
		'ConstructionIndustry': {
			"Areas": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionIndustry/Areas', 'common', args);
			},
			"DataSets": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionIndustry/DataSets', 'common', args);
			},
			"Categories": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionIndustry/Categories', 'common', args);
			},
			"Indicators": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionIndustry/Indicators', 'common', args);
			},
			"DataValues": function (args) {
				return getApiUrl('/api/intelapi/v1/constructionIndustry/DataValues', 'common', args);
			},
		},
		'ProductNotice': {
			"Sign": function (args) {
				return getApiUrl('/api/intelapi/v1/productNotice/Sign', 'common', args);
			},
			"IsSign": function (args) {
				return getApiUrl('/api/intelapi/v1/productNotice/IsSign', 'common', args);
			},
		},
		'agencyService': {
			"Category": function (args) {
				return getApiUrl('/api/intelapi/v1/agencyService/Category', 'common', args);
			},
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/agencyService/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/agencyService/Detail', 'common', args);
			},
			"DetailSZ": function (args) {
				return getApiUrl('/api/intelapi/v1/agencyService/DetailSZ', 'common', args);
			},
			"DetailGD": function (args) {
				return getApiUrl('/api/intelapi/v1/agencyService/DetailGD', 'common', args);
			},
			"Industry": function (args) {
				return getApiUrl('/api/intelapi/v1/agencyService/Industry', 'common', args);
			},
			"Export": function (args) {
				return getApiUrl('/api/intelapi/v1/agencyService/Export', 'common', args);
			},

		},
		'preselectProject': {
			"Add": function (args) {
				return getApiUrl('/api/intelapi/v1/preselectProject/Add', 'common', args);
			},
			"Cancel": function (args) {
				return getApiUrl('/api/intelapi/v1/preselectProject/Cancel', 'common', args);
			},
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/preselectProject/List', 'common', args);
			},
		},
		'project': {
			"Add": function (args) {
				return getApiUrl('/api/intelapi/v1/project/Add', 'common', args);
			},
			"Cancel": function (args) {
				return getApiUrl('/api/intelapi/v1/project/Cancel', 'common', args);
			},
			"List": function (args) {
				return getApiUrl('/api/intelapi/v1/project/List', 'common', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/intelapi/v1/project/Detail', 'common', args);
			},
		},
		'projectContact': {
			"post": function (args) {
				return getApiUrl('/api/intelapi/v1/projectContact/post', 'common', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/intelapi/v1/projectContact/delete', 'common', args);
			},
			"list": function (args) {
				return getApiUrl('/api/intelapi/v1/projectContact/list', 'common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/intelapi/v1/projectContact/detail', 'common', args);
			},
		},
		'projectTodo': {
			"post": function (args) {
				return getApiUrl('/api/intelapi/v1/projectTodo/post', 'common', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/intelapi/v1/projectTodo/delete', 'common', args);
			},
			"list": function (args) {
				return getApiUrl('/api/intelapi/v1/projectTodo/list', 'common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/intelapi/v1/projectTodo/detail', 'common', args);
			},
			"notify": function (args) {
				return getApiUrl('/api/intelapi/v1/projectTodo/notify', 'common', args);
			},
			"read": function (args) {
				return getApiUrl('/api/intelapi/v1/projectTodo/read', 'common', args);
			},
		},
		'ProjectTrack': {
			"post": function (args) {
				return getApiUrl('/api/intelapi/v1/ProjectTrack/post', 'common', args);
			},
			"delete": function (args) {
				return getApiUrl('/api/intelapi/v1/ProjectTrack/delete', 'common', args);
			},
			"list": function (args) {
				return getApiUrl('/api/intelapi/v1/ProjectTrack/list', 'common', args);
			},
			"detail": function (args) {
				return getApiUrl('/api/intelapi/v1/ProjectTrack/detail', 'common', args);
			},
			"trackStatusList": function (args) {
				return getApiUrl('/api/intelapi/v1/ProjectTrack/trackStatusList', 'common', args);
			},
		},
		'home': {
			"Chart": function (args) {
				return getApiUrl('/api/intelapi/v1/home/Chart', 'common', args);
			},
		},

	},
	"metall": {
		"invest": {
			"List": function (args) {
				return getApiUrl('/api/data/v1/invest/List', 'metall', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/data/v1/invest/Detail', 'metall', args);
			},
			"MonitorList": function (args) {
				return getApiUrl('/api/data/v1/invest/MonitorList', 'metall', args);
			},
		},
		"investParam": {
			"List": function (args) {
				return getApiUrl('/api/data/v1/investParam/List', 'metall', args);
			},
			"KeyIndustry": function (args) {
				return getApiUrl('/api/data/v1/investParam/KeyIndustry', 'metall', args);
			},
		},
		"investThread": {
			"Add": function (args) {
				return getApiUrl('/api/data/v1/investThread/Add', 'metall', args);
			},
			"Delete": function (args) {
				return getApiUrl('/api/data/v1/investThread/Delete', 'metall', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/data/v1/investThread/Detail', 'metall', args);
			},
			"Match": function (args) {
				return getApiUrl('/api/data/v1/investThread/Match', 'metall', args);
			},
			"Analyse": function (args) {
				return getApiUrl('/api/data/v1/investThread/Analyse', 'metall', args);
			},
		},
		"InvestCount": {
			"Industry": function (args) {
				return getApiUrl('/api/data/v1/investCount/Industry', 'metall', args);
			},
			"Area": function (args) {
				return getApiUrl('/api/data/v1/investCount/Area', 'metall', args);
			},
			"Enterprise": function (args) {
				return getApiUrl('/api/data/v1/investCount/Enterprise', 'metall', args);
			},
		},
		"LandCount": {
			"Industry": function (args) {
				return getApiUrl('/api/data/v1/landCount/Industry', 'metall', args);
			},
			"Area": function (args) {
				return getApiUrl('/api/data/v1/landCount/Area', 'metall', args);
			},
			"Enterprise": function (args) {
				return getApiUrl('/api/data/v1/landCount/Enterprise', 'metall', args);
			},
		},
		"Land": {
			"List": function (args) {
				return getApiUrl('/api/data/v1/Land/List', 'metall', args);
			},
			"Detail": function (args) {
				return getApiUrl('/api/data/v1/Land/Detail', 'metall', args);
			},
			"MonitorList": function (args) {
				return getApiUrl('/api/data/v1/Land/MonitorList', 'metall', args);
			},
		},
		"LandParam": {
			"landType": function (args) {
				return getApiUrl('/api/data/v1/landParam/LandType/landType', 'metall', args);
			},
			"supplyMode": function (args) {
				return getApiUrl('/api/data/v1/landParam/supplyMode/supplyMode', 'metall', args);
			},
			"landArea": function (args) {
				return getApiUrl('/api/data/v1/landParam/LandArea/landArea', 'metall', args);
			},
			"landIndustry": function (args) {
				return getApiUrl('/api/data/v1/landParam/landIndustry/landIndustry', 'metall', args);
			},
			"KeyIndustry": function (args) {
				return getApiUrl('/api/data/v1/landParam/KeyIndustry', 'metall', args);
			},
			"landLevel": function (args) {
				return getApiUrl('/api/data/v1/landParam/LandLevel/landLevel', 'metall', args);
			},
		},
	},
	"crm":{
		"enterprise": {
			"addtoCRM": function (args) {
				return getApiUrl('/api/crm/v1/enterprise/addToCRM', 'crm', args);
			},
			"isExist": function (args) {
				return getApiUrl('/api/crm/v1/enterprise/isExist', 'crm', args);
			},
			"isExist2": function (args) {
				return getApiUrl('/api/crm/v1/enterprise/isExist2', 'crm', args);
			},
		},
	},
};
export default ajaxapi;